import * as React from 'react';

import * as styles from './styles.css';

interface ILayoutProps {
  /** Ширина закрашенной части. Можно передавать в любой ед.изм., рассчитывая значение вне этого комп-та */
  fillWidth: number | string;
  ref?: React.Ref<HTMLDivElement>;
}

export const Layout: React.FC<ILayoutProps> = ({ fillWidth, ref }) => {
  return (
    <div data-testid="progressBar" ref={ref} className={styles['track']}>
      <div className={styles['fill']} style={{ width: fillWidth }} />
    </div>
  );
};

Layout.displayName = 'Layout';
